// Armado del query string del reporte de artículos sin movimiento.
// Aparte del componente para poder probarlo sin renderizar nada.

export function construirParams({ dias, bodegas, clas, pagina, porPagina, formato,
                                  incluirSinIngreso, contar }) {
  const p = new URLSearchParams();
  p.append("dias", String(dias));
  // El default del backend ya es false: mandarlo siempre solo ensucia la URL.
  if (incluirSinIngreso) p.append("incluir_sin_ingreso", "true");
  if (formato === "csv") {
    p.append("formato", "csv");   // el CSV trae todo, sin paginar
  } else {
    p.append("pagina", String(pagina));
    p.append("por_pagina", String(porPagina));
    // Al pasar de página con los mismos filtros el total ya se conoce.
    if (contar === false) p.append("contar", "false");
  }
  (bodegas || []).forEach(b => p.append("bodegas", b));
  (clas || []).forEach(r => {
    if (!r.id_clasificador) return;
    p.append("mclas", r.id_tipo ? `${r.id_clasificador}:${r.id_tipo}` : r.id_clasificador);
  });
  return p.toString();
}

// El backend solo guarda la ventana de ventas que carga el ERP (`horizonte`).
// El reporte exige "nunca vendido", que en realidad es "no vendido dentro de
// lo cargado": la etiqueta lo hace explícito y espeja la de
// app/services/sin_movimiento.py.
export function textoSinVenta(horizonte) {
  return horizonte?.desde ? `Sin ventas desde ${horizonte.desde}` : "Sin ventas registradas";
}

// Solo aparece con el check de incluir sin ingreso. Dejar la celda vacía se
// leería como "entró hoy", justo lo contrario de lo que pasa.
export function textoSinIngreso() {
  return "Sin ingreso registrado";
}
